'use strict';

var _enums = require('../enums');

var _enums2 = _interopRequireDefault(_enums);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var _ = require('lodash');
var stateCodes = require('../enums/stateCodes');
var DIACRITIC_REMOVAL_MAP = require('../enums/diacriticRemovalMap');
var moment = require('moment');

// constants


var NUM_CITY_LETTERS_TO_CAPTURE = 3;
/**
 * Get the selected time slot for a booking request
 * @param {Request} request
 * @return {Object}
 */

exports.selectedTimeSlot = function (request) {
  var theSpace = exports.selectedSpace(request);
  if (!theSpace) {
    return null;
  }
  if (!request.data.date || _.isNil(request.data.time)) {
    return null;
  }

  return theSpace.data.timeSlots[request.data.timeSlot];
};

/**
 * get the selected space for a booking request
 * @param {Request} request
 * @return {Object}
 */
exports.selectedSpace = function (request) {
  var spaceIdx = _.get(request, 'data.space');
  if (!_.isNumber(spaceIdx) || !request.venue) {
    return null;
  }
  return request.venue.data.spaces[spaceIdx];
};

/**
 * get reservation Id for a booking request
 * @param {Request} request
 * @return {String}
 */

exports.reservationId = function (request) {
  var alreadyExistingId = _.get(request, 'admin.reservationId');
  if (alreadyExistingId) {
    return alreadyExistingId;
  }

  var readableId = _.get(request, 'admin.readableId');
  var requestState = _.get(request, 'venue.data.address.state');
  var stateCode = stateCodes[requestState] ? stateCodes[requestState] : stateCodes['Other'];
  var city = _.get(request, 'venue.data.address.city');

  if (readableId && stateCode && city) {
    var one = 'R' + readableId.toString();
    var two = 'S' + stateCode;
    var three = city ? _.toUpper(city.slice(0, NUM_CITY_LETTERS_TO_CAPTURE)) : '';
    return one + two + three;
  }
};

/**
 * Host(admin) commission percentage virtual for a request
 *
 * @param {Request} request
 * @return {Number}
 */
exports.hostCommissionPercentage = function (request) {
  var path = 'admin.commissionPercentage';

  var commissionPercentage = _.get(request, path);
  if (_.gte(commissionPercentage, 0)) {
    return commissionPercentage;
  } else {
    return _.get(request.venue, path);
  }
};

/**
 * Credit card fee precentage virtual for a requst
 *
 * @param {Request} request
 * @return {Number}
 */
exports.cardFeePercentage = function (request) {
  var path = 'admin.cardFeePercentage';
  var cardFeePercentage = _.get(request, path);
  if (_.gte(cardFeePercentage, 0)) {
    return cardFeePercentage;
  } else {
    return _.get(request.venue, path);
  }
};

/**
 * Get end time for a booking request based on its start time and duration
 * For instance, a request with start time `1130` and duration `120` ends
 * at `1330`
 *
 * @param {Request} request
 * @return {Number}
 */

exports.getEndTime = function (request) {
  var duration = _.get(request, 'data.duration');
  if (!duration) {
    return null;
  }

  var startTimeMins = Math.floor(request.data.time / 100) * 60 + request.data.time % 100;

  var endTimeMins = startTimeMins + duration;

  return Math.floor(endTimeMins / 60) * 100 + endTimeMins % 60;
};

/**
 * Get duration minutes from a start and end time
 * For instance, if a request starts at `1130` and ends at `1830`,
 * the duration in minutes is 420
 *
 * @param {Number} start
 * @param {Number} end
 * @return {Number}
 */
exports.getDurationMinsFromStartAndEndTime = function (start, end) {
  if (!_.isNumber(start) || !_.isNumber(end)) {
    return;
  }
  var startTimeMins = Math.floor(start / 100) * 60 + start % 100;
  var endTimeMins = Math.floor(end / 100) * 60 + end % 100;
  return endTimeMins - startTimeMins;
};

/**
 * Get the time span for a request and display it
 * For instance, for a start time of 1130 and duration of 120,
 * it would return a string of '11:30am - 1:30pm'
 */
exports.timeSpan = function (request, delta) {
  var str = '';
  var startTime;
  var endTime;

  if (!request || !_.isFinite(request.data.time) || !request.data.duration) {
    return '';
  }
  if (delta && delta['data.time'] && delta['data.time'].newValue) {
    var newValue = delta['data.time'].newValue;
    newValue = newValue > 2400 ? newValue - 2400 : newValue;
    var startTimeStr = Math.floor(newValue / 100) + ':' + newValue % 100;
    startTime = moment(startTimeStr, 'H:m');
  } else {
    var newValue = request.data.time;
    newValue = newValue > 2400 ? newValue - 2400 : newValue;
    var startTimeStr = Math.floor(newValue / 100) + ':' + newValue % 100;
    startTime = moment(startTimeStr, 'H:m');
  }

  if (delta && delta['data.duration'] && delta['data.duration'].newValue) {
    endTime = startTime.clone().add(delta['data.duration'].newValue, 'minutes');
  } else {
    endTime = startTime.clone().add(request.data.duration, 'minutes');
  }

  return startTime.format('h:mma') + ' - ' + endTime.format('h:mma');
};

/**
 * Get the url for a given request for a host or guest
 *
 * @param {Config} config
 * @param {Request}
 * @param {Options} { guest: true || host: true }
 * @return {String}
 */
exports.getUrl = function (config, request, options) {
  var BASE_URL = _.get(config, 'domain') + '/';
  var conversationId = _.get(request, 'conversation._id', request.conversation);
  var END_URL = 'conversation/' + conversationId;

  return '' + BASE_URL + (options.host ? 'venue/' : 'client/') + END_URL;
};

exports.getReceiptUrl = function (_ref) {
  var config = _ref.config,
      request = _ref.request,
      receipt = _ref.receipt;

  var conversationId = _.get(request, 'conversation._id', request.conversation);
  return _.get(config, 'domain') + '/conversation/' + conversationId + '/receipts?receipt=' + receipt;
};

/**
 * Gets a request's food and beverage minimum cents. Different from
 * the price module's `foodAndBeverageMin` in that this will
 * explicitly return undefined if it is not set
 *
 * @param {Request}
 * @return {Boolean|Undefined}
 */
exports.fbMinCents = function (request) {
  var hostFbMin = _.get(request, 'host.foodBeverageMinCents');
  if (_.isFinite(hostFbMin)) {
    return hostFbMin;
  }
  return undefined;
};

/**
 * Get a request's payment schedule, either manual or regular
 *
 * @api public
 * @params {Request} request
 * @return {Array}
 */
exports.paymentSchedule = function (request) {
  return _.get(request, 'data.payment.schedule', []);
};

/**
 * Get the nth completed payment in a request's schedule, either manual or regular
 *
 * @api public
 * @params {Request} request
 * @params {Number} number
 * @return {Object}
 */
exports.nthCompletedPayment = function (request, num) {
  var schedule = exports.paymentSchedule(request);
  var completed = _.filter(schedule, function (payment) {
    return payment.state === 'COMPLETED';
  });

  return completed[parseInt(num, 10) - 1];
};

exports.nthCompletedIntermediatePayment = function (request, num) {
  var schedule = exports.paymentSchedule(request);
  var intermediate = _.filter(schedule, function (payment) {
    return payment.state === 'COMPLETED' && payment.title === 'INTERMEDIATE';
  });

  return intermediate[parseInt(num, 10) - 1];
};

exports.nthCompletedOveragePayment = function (request, num) {
  var schedule = exports.paymentSchedule(request);
  var overage = _.filter(schedule, function (payment) {
    return payment.state === 'COMPLETED' && payment.title === 'OVERAGE';
  });

  return overage[parseInt(num, 10) - 1];
};

exports.depositPayment = function (request) {
  var schedule = exports.paymentSchedule(request);
  var completed = _.filter(schedule, function (payment) {
    return payment.state === 'COMPLETED';
  });
  return completed[0];
};

exports.balancePayment = function (request) {
  var schedule = exports.paymentSchedule(request);
  var completed = _.filter(schedule, function (payment) {
    return payment.state === 'COMPLETED';
  });
  return completed.find(function (payment) {
    return payment.title === 'BALANCE';
  });
};

exports.overagePayment = function (request) {
  var schedule = exports.paymentSchedule(request);
  var completed = _.filter(schedule, function (payment) {
    return payment.state === 'COMPLETED';
  });
  return [].concat(_toConsumableArray(completed.reverse())).find(function (payment) {
    return payment.title === 'OVERAGE';
  });
};

exports.intermediatePayment = function (request) {
  var schedule = exports.paymentSchedule(request);
  var completed = _.filter(schedule, function (payment) {
    return payment.state === 'COMPLETED';
  });
  return completed.find(function (payment) {
    return payment.title === 'INTERMEDIATE';
  });
};

exports.contractedPayment = function (request) {
  return exports.balancePayment(request) || exports.depositPayment(request);
};

exports.generateIntermediateDescriptor = function (num) {
  var ordinal = _enums2.default.intermediatePaymentOrdinals[num];
  var descriptor = [ordinal + '_INTERMEDIATE_REFUND_FULL', ordinal + '_INTERMEDIATE_REFUND_PARTIAL'];
  return descriptor;
};

exports.generateOverageDescriptor = function (num) {
  var ordinal = _enums2.default.intermediatePaymentOrdinals[num];
  var descriptor = [ordinal + '_OVERAGE_REFUND_FULL', ordinal + '_OVERAGE_REFUND_PARTIAL'];
  return descriptor;
};

exports.getRefundedAmount = function (schedule, descriptor) {
  var refunded = _.filter(schedule, function (s) {
    return s.state === 'REFUNDED' && descriptor.includes(s.descriptor);;
  });
  var totalRefunded = refunded.reduce(function (total, r) {
    return total + r.amountCents;
  }, 0);
  return totalRefunded;
};

exports.depositRefund = function (request) {
  var schedule = exports.paymentSchedule(request);
  var descriptor = ['DEPOSIT_REFUNDED_FULL', 'DEPOSIT_REFUNDED_PARTIAL'];

  var totalRefunded = this.getRefundedAmount(schedule, descriptor);
  return totalRefunded;
};

exports.balanceRefund = function (request) {
  var schedule = exports.paymentSchedule(request);
  var descriptor = ['BALANCE_REFUNDED_FULL', 'BALANCE_REFUNDED_PARTIAL'];

  var totalRefunded = this.getRefundedAmount(schedule, descriptor);
  return totalRefunded;
};

exports.nthIntermediateRefund = function (request, num) {
  var schedule = exports.paymentSchedule(request);
  var descriptor = this.generateIntermediateDescriptor(num);

  var totalRefunded = this.getRefundedAmount(schedule, descriptor);
  return totalRefunded;
};

exports.nthOverageRefund = function (request, num) {
  var schedule = exports.paymentSchedule(request);
  var descriptor = this.generateOverageDescriptor(num);

  var totalRefunded = this.getRefundedAmount(schedule, descriptor);
  return totalRefunded;
};

exports.getRefund = function (request, slug, num) {
  var schedule = exports.paymentSchedule(request);
  if (!schedule.length) {
    return;
  }
  if (slug === 'deposit') {
    return this.depositRefund(request);
  } else if (slug === 'balance') {
    return this.balanceRefund(request);
  } else if (slug === 'intermediate') {
    return this.nthIntermediateRefund(request, num);
  } else if (slug === 'overage') {
    return this.nthOverageRefund(request, num);
  }
};

/**
 * Tracks an admin event in a request's admin history array
 *
 * @api public
 * @params {Request} request, required
 * @params {String} event, required
 * @params {Number} time, optional
 * @mutates `request`
 */
exports.trackAdminEvent = function (request, event, time) {
  if (!request || !event) {
    return;
  }

  request.admin.history.push({
    event: event,
    time: time || Date.now()
  });
};

exports.gratuityPercentage = function (request) {
  var requestGratuity = _.get(request, 'data.gratuityPercentage');
  if (!_.isFinite(requestGratuity)) {
    return _.get(request, 'venue.data.fees.gratuityPercentage');
  }

  return requestGratuity;
};
/**
 * Apply the given delta to a request.
 *
 * NOTE: Mongoose 4.6.1 fixes an issue allowing us to use `document.set`
 * instead of `_.set`. However, there are other bugs in Mongoose 4.6.1 that
 * prevent us from updating to it. Once we've confirmed that some of the issues
 * relating to cursor population, issues with `document.save()` are fixed, we
 * can upgrade and safely use `document.set()`
 *
 * @param {Request} request
 * @param {Array} delta
 * @param {Array} [skipPaths] array of regexps, skip if path matches one
 * @mutates request
 */
exports.applyDelta = function (request, delta, skipPaths) {
  _.each(delta, function (delta) {
    var checkRegexp = function checkRegexp(re) {
      return re.test(delta.path);
    };
    if (skipPaths && _.some(skipPaths, checkRegexp)) {
      return;
    }

    var deltaPath = delta.path.toString();
    if (delta.deleted) {
      exports._deltaUnset(request, deltaPath);
    } else {
      _.set(request, deltaPath, delta.newValue);
    }

    if (request.markModified) {
      request.markModified(deltaPath);
    }
  });
};

exports.applyDeltaOnDocument = function (request, delta, skipPaths) {
  _.each(delta, function (delta) {
    var checkRegexp = function checkRegexp(re) {
      return re.test(delta.path);
    };
    if (skipPaths && _.some(skipPaths, checkRegexp)) {
      return;
    }

    var deltaPath = delta.path.toString();
    if (delta.deleted) {
      exports._deltaUnset(request, deltaPath);
    } else {
      request.set(deltaPath, delta.newValue);
    }

    request.markModified(deltaPath);
  });
};

/**
 * NOTE: Consult team before changing this function. This and `applyDeltas`
 * is one of the most important functions in the codebase.
 *
 * Unset the value at a given path in a request. DO NOT USE `_.unset`,
 * because it creates sparse arrays. Moreover, we don't actually want
 * to delete items in arrays, we want to mark them as deleted. Deleting
 * items in arrays causes state management issues, particularly when deltas
 * are applied at specific indices (i.e. if the item at index 0 is spliced,
 * a delta for an item at a larger index would in reality apply to the item at
 * that index - 1)
 *
 *
 * @param {Request} request, a booking request
 * @param {String} path
 * @mutates `request`
 */
exports._deltaUnset = function (obj, path) {
  var cur = obj;
  var pieces = path.split('.');
  for (var i = 0; i < pieces.length - 1; ++i) {
    cur = cur[pieces[i]];
    if (!cur) {
      return;
    }
  }
  path = pieces[pieces.length - 1];
  if (Array.isArray(cur)) {
    var asNum = Number(path);
    if (isNaN(asNum)) {
      delete cur[path];
    } else {
      var val = _.get(cur, path);
      if (val) {
        _.set(cur, path + '.isDeleted', true);
      }
    }
  } else {
    delete cur[path];
  }
};

exports.applyLastCounteroffer = function (request) {
  var last = request.counteroffers[request.counteroffers.length - 1];
  if (last && ['INIT', 'READY'].includes(last.state)) {
    if (request.toObject) {
      exports.applyDeltaOnDocument(request, last.delta);
    } else {
      exports.applyDelta(request, last.delta);
    }
  }
};

exports.dynamicDescriptor = function (bookingRequest) {
  var stopWords = ['a', 'an', 'the', 'and', 'at'];
  var maxAllowedLength = 14;

  var venueDescriptor = bookingRequest.venue.data.name.split(' ').filter(function (word) {
    return !stopWords.includes(word);
  }).join(' ');

  DIACRITIC_REMOVAL_MAP.forEach(function (diacriticMap) {
    venueDescriptor = venueDescriptor.replace(diacriticMap.letters, diacriticMap.base);
  });

  venueDescriptor = venueDescriptor.replace(/\W+/g, '').substr(0, maxAllowedLength);

  return 'SixPlus*' + venueDescriptor;
};

exports.initMenuRequestFromMenu = function (bookingRequest, menu) {
  if (!bookingRequest.data.menu) {
    bookingRequest.data.menu = {};
  }
  if (menu.none) {
    bookingRequest.data.menu._id = null;
    bookingRequest.data.menu.name = _.get(menu, 'data.name', 'No Menu Desired');
    bookingRequest.data.menu.none = true;
    bookingRequest.data.menu.coverImage = null;
    bookingRequest.data.menu.numGuests = null;
    bookingRequest.data.menu.pricePerGuestCents = null;
  } else {
    bookingRequest.data.menu.none = false;
    bookingRequest.data.menu._id = menu._id;
    bookingRequest.data.menu.name = menu.data.name;
    bookingRequest.data.menu.type = menu.data.type;
    bookingRequest.data.menu.description = menu.data.description;
    bookingRequest.data.menu.photos = menu.data.photos;
    bookingRequest.data.menu.coverIndex = menu.data.coverIndex;
    bookingRequest.data.menu.courses = menu.data.courses;
    bookingRequest.data.menu.coverImage = _.get(menu, 'coverImage.url');
    bookingRequest.data.menu.numGuests = bookingRequest.data.groupSize;
    bookingRequest.data.menu.pricePerGuestCents = menu.data.priceInCents;
    bookingRequest.data.menu.isCustom = !!menu.isCustom;
  }
  return bookingRequest;
};